import React, { useState, useEffect, useRef } from "react";
import Box from "@mui/material/Box";
import {
  Card,
  Container,
  Row,
  Col,
  Alert,
  ButtonGroup,
  Dropdown,
  Modal,
  Button,
  Table,
  Form,
} from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import _ from "lodash";
import { handleIsActive, validateAndSanitizeUrl } from "../util/common";
import {
  addNewLoinc,
  fetchLoincById,
  updateLoincRecord,
} from "../services/loincCodes-service";
import { fetchConditions } from "../services/conditions-service";
import LOINCFormReportingLoincsCard from "./LOINCFormReportingLoincsCard";
import { fetchCodeSetTable } from "../services/referenceTable-service";
import RatioTextField from "./common/RatioTextField";
import {
  S3_URL,
  OPERATORS_WITH_RATO,
  TEST_RESULT_OPTIONS,
} from "../services/Constants";
import { Autocomplete, TextField } from "@mui/material";
import {
  addNewLOINCForIDSS,
  updateLoincForIDSS,
} from "../services/ids-service";

const LOINCForm = () => {
  const [form, setForm] = useState({});
  const [validated, setValidated] = useState(false);
  const [alertMessage, setAlertMessage] = useState();
  const [conditions, setConditions] = useState([]);
  const [lookUpCondition, setLookUpCondition] = useState(false);
  const [isAcceptableByRE, setIsAcceptableByRE] = useState(false);
  const [testMethodValues, setTestMethodValues] = useState([]);
  const [scaleTypeValues, setScaleTypeValues] = useState([]);
  const [propertyValues, setPropertyValues] = useState([]);
  const [timeAspectValues, setTimeAspectValues] = useState([]);
  const [specimenSourceValues, setSpecimenSourceSite] = useState([]);
  const [codeSystemValues, setCodeSystem] = useState([]);
  const childFormRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [qnInterpetationChecked, setQnInterpetationChecked] = useState(false);
  const initialInterpretation = [
    {
      qnInterpretationConditions: [
        {
          sourceObject: "QNInterpretation",
          sourceField: "value1",
          operator: "",
          valueRHS: "",
          seqNum: "1",
          logicalOperator: "",
          rowNum: 1,
        },
        {
          sourceObject: "QNInterpretation",
          sourceField: "value2",
          operator: "",
          valueRHS: "",
          seqNum: "2",
          logicalOperator: "&&",
          rowNum: 1,
        },
      ],
      qnInterpretationActions: [
        {
          sourceObject: "QNInterpretation",
          sourceField: "output",
          operator: "Equal to",
          valueRHS: "",
          seqNum: "1",
          logicalOperator: "",
          rowNum: 1,
        },
      ],
    },
  ];
  const [interpretations, setInterpretations] = useState(
    JSON.parse(JSON.stringify(initialInterpretation))
  );
  const [unitData, setUnitData] = useState([]);
  const [selectedConditions, setSelectedConditions] = useState([]);
  const [testTypeOptions, setTestTypeOptions] = useState([]);

  const setField = (field, value) => {
    setForm({
      ...form,
      [field]: value,
    });
  };

  const setQnInterpretaionsField = (field, value) => {
    setForm({
      ...form,
      qnInterpretations: {
        ...form.qnInterpretations,
        [field]: value,
      },
    });
  };
  const getUnitDropdownValues = async () => {
    let response = await fetchCodeSetTable("Units of Measure");
    if (response.ok) {
      let data = await response.json();
      setUnitData(data.refTableValues);
    }
  };
  const cancelForm = () => {
    navigate("/LOINCCodes", {
      state: {
        filter: location?.state?.filter,
        pageNo: location?.state?.pageNo,
      },
    });
  };

  const handleBackRouteMessage = () => {
    return (
      <Link
        to="/LOINCCodes"
        className="linkStyle"
        state={{
          filter: location?.state?.filter,
          pageNo: location?.state?.pageNo,
        }}
      >
        Back to LOINC Table
      </Link>
    );
  };

  const showTitle = () => {
    let message = "Add New LOINC";
    if (location?.state?.action === "update") {
      message = "Update LOINC";
    }
    return message;
  };

  const showSubtitle = () => {
    let message = "Add the details of the LOINC";
    if (location?.state?.action === "update") {
      message = "Update the details of the LOINC";
    }
    return message;
  };

  const getLoincById = async () => {
    let loincId = location.state.selectedRow.loincId;
    let response = await fetchLoincById(loincId);
    if (response.ok) {
      let data = await response.json();
      if (data != null) {
        const idssConditionIdsArray = data?.idssConditionIds?.split(",")?.map(Number);
        conditions.length > 0 &&
          setSelectedConditions(
            conditions.filter((item) =>
              idssConditionIdsArray?.includes(item.conditionId)
            )
          );
        setForm(data);
        setLookUpCondition(data.lookupCondition);
        setIsAcceptableByRE(data.isAcceptableByRE);
        setInterpretations(
          data?.qnInterpretations?.qnInterpretationList
            ? data?.qnInterpretations?.qnInterpretationList
            : initialInterpretation
        );
        setQnInterpetationChecked(data?.qnInterpretation);
        populateTestType(data);
      }
    } else {
      let error = await response.json();
      setAlertMessage(error?.description);
    }
  };

  const populateTestType = async (data) => {
    let condition = conditions.find(
      (item) => item.conditionId?.toString() === data?.conditionId?.toString()
    );
    if (
      condition != null &&
      (condition.conditionName === "Syphilis" ||
        condition.conditionName.includes("Hepatitis C") ||
        condition.conditionName.includes("Lyme Disease"))
    ) {
      if (condition?.conditionName.includes("Hepatitis B"))
        setTestTypeOptions(["AB", "RNA", "Genotype"]);
      if (condition?.conditionName.includes("Hepatitis C"))
        setTestTypeOptions(["AB", "RNA", "Genotype"]);
      if (condition?.conditionName.includes("Syphilis"))
        setTestTypeOptions(["Treponemal", "Non-Treponemal"]);
      if (condition?.conditionName.includes("Lyme Disease"))
        setTestTypeOptions(["Tier One", "Tier Two", "Confirmatory"]);
    }
  };

  const getConditions = async () => {
    let response = await fetchConditions();
    if (response.ok) {
      let data = await response.json();
      if (data?.length > 0) {
        setConditions(data);
      } else {
        setAlertMessage(data?.description);
      }
    } else {
      let error = await response.json();
      setAlertMessage(error?.description);
    }
  };

  const addLoinc = async () => {
    let data1 = await addNewLOINCForIDSS(form);
    form.idssConditionNames = form?.idssConditionNames.join(",");
    if (data1?.statusCode === "200") {
      let data = await addNewLoinc(form);
      if (data.loincId != null) {
        return { isAdded: true };
      } else {
        return { isAdded: false, message: data?.description };
      }
    } else {
      return {
        isAdded: false,
        message:
          "Error, synchronization unsuccessful with IDSS LOINC Table: " +
          data1?.message,
      };
    }
  };

  const updateLoinc = async () => {
    let data1 = await updateLoincForIDSS(form);
    form.idssConditionNames = form?.idssConditionNames.join(",");
    if (data1?.statusCode === "200") {
      let data = await updateLoincRecord(form);
      if (data.loincId != null) {
        return { isUpdated: true };
      } else {
        return { isUpdated: false, message: data?.description };
      }
    } else {
      return {
        isUpdated: false,
        message:
          "Error, synchronization unsuccessful with IDSS LOINC Table: " +
          data1?.message,
      };
    }
  };

  const handleSubmmit1 = async (event) => {
    event.preventDefault();
    setValidated(true);
    form.qnInterpretation = qnInterpetationChecked;
    if (qnInterpetationChecked) {
      if (!form.qnInterpretations) {
        form.qnInterpretations = {};
      }
      form.qnInterpretations.qnInterpretationList = interpretations;
    }
    if (!showTestTypeField()) {
      form.testType = null;
    }
    if (lookUpCondition) {
      form.conditionId = null;
      form.testType = null;
      form.isAcceptableByRE = true;
    } else {
      form.isAcceptableByRE = isAcceptableByRE;
    }
    form.lookupCondition = lookUpCondition;
    form.idssConditionIds = selectedConditions ? selectedConditions
      .map((v) => v?.conditionId)
      .join(",") : "";
    form.idssConditionNames = selectedConditions
      ? selectedConditions.map((v) => v?.conditionName)
      : [""];

    if (event.currentTarget.checkValidity() === true) {
      if (location?.state?.selectedRow?.loincId != null) {
        let response = await updateLoinc();
        navigate("/LOINCCodes", {
          state: {
            isUpdated: response.isUpdated,
            message: response?.message,
            filter: location?.state?.filter,
            pageNo: location?.state?.pageNo,
          },
        });
      } else {
        let response = await addLoinc();
        navigate("/LOINCCodes", {
          state: {
            isAdded: response.isAdded,
            message: response?.message,
            filter: location?.state?.filter,
            pageNo: location?.state?.pageNo,
          },
        });
      }
    }
  };

  const getDropdownValues = async (tableName) => {
    let response = await fetchCodeSetTable(tableName);
    if (response.ok) {
      let data = await response.json();
      if (tableName === "Test Method") {
        setTestMethodValues(data.refTableValues);
      } else if (tableName === "Scale Type") {
        setScaleTypeValues(data.refTableValues);
      } else if (tableName === "Property") {
        setPropertyValues(data.refTableValues);
      } else if (tableName === "Time Aspect") {
        setTimeAspectValues(data.refTableValues);
      } else if (tableName === "Specimen Source") {
        setSpecimenSourceSite(data.refTableValues);
      } else if (tableName === "Code System") {
        setCodeSystem(data.refTableValues);
      }
    }
  };
  const CustomToggleNull = React.forwardRef(({ children, onClick }, ref) => (
    <a
      href=""
      className="blackTextNull"
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      &#x22EE;
    </a>
  ));

  const CustomToggleText = React.forwardRef(({ children, onClick }, ref) => (
    <a
      href=""
      className="blackTextonText"
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      &#x22EE;
    </a>
  ));

  const CustomToggleRatio = React.forwardRef(({ children, onClick }, ref) => (
    <a
      href=""
      className="blackTextRatio"
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      &#x22EE;
    </a>
  ));

  const findMax = (copyInterpretations) => {
    let max = 0;
    copyInterpretations.map((interpretation) => {
      if (interpretation?.qnInterpretationActions[0]?.rowNum > max)
        max = interpretation?.qnInterpretationActions[0]?.rowNum;
    });
    return max;
  };

  const addFields = () => {
    let copy = JSON.parse(JSON.stringify(initialInterpretation[0])); //Deep copy

    let maxRowNum = findMax(interpretations);
    copy.qnInterpretationConditions[0].rowNum = maxRowNum + 1;
    copy.qnInterpretationConditions[1].rowNum = maxRowNum + 1;
    copy.qnInterpretationActions[0].rowNum = maxRowNum + 1;

    copy.qnInterpretationConditions[0].operator =
      interpretations[0].qnInterpretationConditions.find(
        (obj) => obj.seqNum == 1
      )?.operator;
    copy.qnInterpretationConditions[1].operator =
      interpretations[0].qnInterpretationConditions.find(
        (obj) => obj.seqNum == 2
      )?.operator;

    let updatedInterpretations = [...interpretations].concat(copy);
    setInterpretations(updatedInterpretations);
  };

  const removeRow = (interpretation, index) => {
    let copyInterpretations = [...interpretations];
    if (copyInterpretations.length === 1)
      copyInterpretations = [...initialInterpretation];
    else
      copyInterpretations = copyInterpretations.filter(
        (obj) =>
          obj?.qnInterpretationActions[0]?.rowNum !==
          interpretation?.qnInterpretationActions[0]?.rowNum
      );

    setInterpretations(copyInterpretations);
  };

  const setOperator = (seqNum, value) => {
    let copyInterpretations = [...interpretations];

    copyInterpretations.forEach((obj) => {
      let Y = obj.qnInterpretationConditions.find(
        (obj) => obj.seqNum == seqNum
      );
      Y["valueRHS"] = "";
      Y["operator"] = value;
    });
    setInterpretations(copyInterpretations);
  };

  const updateInputDecision = (interpretation, index, seqNum, value) => {
    let copyInterpretations = [...interpretations];

    let X = copyInterpretations[index];

    let Y = X.qnInterpretationConditions.find((obj) => obj.seqNum == seqNum);
    Y["valueRHS"] = value;

    setInterpretations(copyInterpretations);
  };

  const updateInputDecisionOutput = (interpretation, index, value) => {
    let copyInterpretations = [...interpretations];
    let X = copyInterpretations[index];
    let Y = X.qnInterpretationActions[0];
    Y["valueRHS"] = value;
    setInterpretations(copyInterpretations);
  };

  const showTestTypeField = () => {
    let show = false;
    let condition = conditions.find(
      (item) => item.conditionId?.toString() === form?.conditionId?.toString()
    );
    if (
      !lookUpCondition &&
      condition != null &&
      (condition.conditionName === "Syphilis" ||
        condition.conditionName.includes("Hepatitis C") ||
        condition.conditionName.includes("Lyme Disease"))
    ) {
      show = true;
    }
    return show;
  };

  const validateDecisionTable = () => {
    let required = false;
    interpretations.forEach((item) => {
      if (
        item?.qnInterpretationConditions?.[0].valueRHS !== "" ||
        item?.qnInterpretationConditions?.[1].valueRHS !== "" ||
        item?.qnInterpretationConditions?.[0].operator !== "" ||
        item?.qnInterpretationConditions?.[1].operator !== "" ||
        item?.qnInterpretationActions?.[0].valueRHS !== ""
      ) {
        required = true;
      }
    });
    return required;
  };

  useEffect(() => {
    setQnInterpetationChecked(form?.scaleType?.toLowerCase().includes("quantitative"));
  }, [form.scaleType]);

  useEffect(() => {
    getConditions();
    getDropdownValues("Test Method");
    getDropdownValues("Scale Type");
    getDropdownValues("Property");
    getDropdownValues("Time Aspect");
    getDropdownValues("Specimen Source");
    getDropdownValues("Code System");
  }, []);

  useEffect(() => {
    location?.state?.selectedRow?.loincId != null &&
      conditions.length > 0 &&
      getLoincById();
  }, [conditions]);

  useEffect(() => {
    getUnitDropdownValues();
  }, []);

  return (
    <>
      <Container fluid className="errorMessageContainer">
        <Row className="tableTitle generalFont">{showTitle()}</Row>
        <Row
          className="tableSubtitle generalFont"
          style={{ width: "95%", paddingRight: "30px" }}
        >
          <Col style={{ paddingLeft: "0px" }}>{showSubtitle()}</Col>
          <Col style={{ display: "flex", justifyContent: "end" }}>
            {handleBackRouteMessage()}
          </Col>
        </Row>
        {alertMessage && (
          <Alert
            style={{ marginRight: "175px" }}
            variant={"danger"}
            show={alertMessage !== null && alertMessage !== "undefined"}
            onClose={() => {
              setAlertMessage();
            }}
            dismissible
          >
            {alertMessage}
          </Alert>
        )}
        <Row style={{ marginRight: "54px", marginTop: "10px" }}>
          <Box
            sx={{
              width: "100%",
              typography: "body1",
              paddingLeft: "0px",
              paddingRight: "0px",
            }}
          >
            <Form onSubmit={handleSubmmit1} noValidate validated={validated}>
              <Card className="card">
                <Row style={{ padding: "40px 40px 0 40px" }}>
                  <div className="cardBody" style={{ marginBottom: "40px" }}>
                    <img
                      src={`${validateAndSanitizeUrl(
                        S3_URL
                      )}rules-details-icon.png`}
                      style={{
                        width: "20px",
                        height: "18px",
                        marginRight: "15px",
                      }}
                      alt=""
                    ></img>
                    LOINC Details
                  </div>
                  <Col>
                    <Form.Group className="mb-3" controlId="form.loincCode">
                      <React.Fragment>
                        <Form.Label className="modalLabel generalFont">
                          LOINC Code <i className="text-danger">(required)</i>
                        </Form.Label>
                      </React.Fragment>
                      <Form.Control
                        className="modalInput generalFont"
                        type="text"
                        placeholder="Hint Text"
                        autoFocus
                        required
                        maxLength={250}
                        value={form.loincCode}
                        onChange={(e) => setField("loincCode", e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="form.conditionId">
                      <Form.Label className="modalLabel generalFont">
                        Condition{" "}
                        {!lookUpCondition && (
                          <i className="text-danger">(required)</i>
                        )}
                      </Form.Label>
                      <Form.Select
                        className="modalInput generalFont"
                        aria-label="Choose Item"
                        required={!lookUpCondition}
                        disabled={lookUpCondition}
                        value={
                          lookUpCondition
                            ? ""
                            : form?.conditionId != null
                            ? form?.conditionId
                            : form?.condition?.conditionId
                        }
                        onChange={(e) => {
                          let condition = conditions.find(
                            (item) =>
                              item.conditionId?.toString() ===
                              e.target.value?.toString()
                          );
                          setSelectedConditions([condition]);

                          setField("conditionId", e.target.value);
                          if (condition.conditionName.includes("Hepatitis B"))
                            setTestTypeOptions(["AB", "RNA", "Genotype"]);
                          if (condition.conditionName.includes("Hepatitis C"))
                            setTestTypeOptions(["AB", "RNA", "Genotype"]);
                          if (condition.conditionName.includes("Syphilis"))
                            setTestTypeOptions([
                              "Treponemal",
                              "Non-Treponemal",
                            ]);
                          if (condition?.conditionName.includes("Lyme Disease"))
                            setTestTypeOptions([
                              "Tier One",
                              "Tier Two",
                              "Confirmatory",
                            ]);
                        }}
                        feedback="You must agree before submitting."
                      >
                        <option hidden value="">
                          Choose Item
                        </option>
                        {_.sortBy(conditions, ["conditionName"]).map(
                          (entry) => {
                            return (
                              <option
                                key={entry.conditionId}
                                value={entry.conditionId}
                              >
                                {entry.conditionName}
                              </option>
                            );
                          }
                        )}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Row>
                      <Form.Check
                        style={{ marginLeft: "50px", marginTop: "15px" }}
                        name="lookUp"
                        value={lookUpCondition}
                        type="checkbox"
                        label="LOINC is Not Condition Specific  in Rules Engine"
                        inline
                        onChange={(e) => {
                          setField("conditionId", "");
                          setLookUpCondition(!lookUpCondition);
                          setIsAcceptableByRE(false);
                          let condition = conditions.find(
                            (item) =>
                              item.conditionId?.toString() ===
                              form?.conditionId?.toString()
                          );
                          setSelectedConditions();
                        }}
                        checked={lookUpCondition}
                      />
                    </Row>
                    {!lookUpCondition && (
                      <Row>
                        <Form.Check
                          style={{ marginLeft: "50px", marginTop: "15px" }}
                          name="lookUp"
                          value={isAcceptableByRE}
                          type="checkbox"
                          label="Acceptable by Rules Engine"
                          inline
                          onChange={(e) => {
                            setIsAcceptableByRE(!isAcceptableByRE);
                          }}
                          checked={isAcceptableByRE}
                        />
                      </Row>
                    )}
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="form.conditionId">
                      <Form.Label className="modalLabel generalFont">
                        Conditions for Dropdown Values in IDSS{" "}
                      </Form.Label>
                      {conditions && (
                        <Autocomplete
                          multiple
                          id="tags-standard"
                          options={conditions.sort(
                            (a, b) =>
                              -b.conditionName.localeCompare(a.conditionName)
                          )}
                          getOptionLabel={(option) => {
                            return option?.conditionName?.trim();
                          }}
                          value={selectedConditions ? selectedConditions : []}
                          onChange={(event, newValue) => {
                            setSelectedConditions(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="standard"
                              placeholder="Search Condition"
                            />
                          )}
                          sx={{
                            width: "96%",
                          }}
                        />
                      )}
                    </Form.Group>
                  </Col>
                </Row>
                <Row style={{ padding: "30px 40px 0 40px" }}>
                  <Form.Group className="mb-3" controlId="form.loincLongName">
                    <Form.Label className="modalLabel generalFont">
                      Test performed LOINC Long name{" "}
                      <i className="text-danger">(required)</i>
                    </Form.Label>
                    <Form.Control
                      className="modalInput generalFont"
                      type="text"
                      placeholder="Hint Text"
                      required
                      value={form.loincLongName}
                      onChange={(e) =>
                        setField("loincLongName", e.target.value)
                      }
                    ></Form.Control>
                  </Form.Group>

                  <Form.Group
                    className="mb-3"
                    controlId="form.loincShortName"
                    style={{ paddingTop: "40px" }}
                  >
                    <Form.Label className="modalLabel generalFont">
                      LOINC Short Name
                    </Form.Label>
                    <Form.Control
                      className="modalInput generalFont"
                      type="text"
                      placeholder="Hint Text"
                      value={form.loincShortName}
                      onChange={(e) =>
                        setField("loincShortName", e.target.value)
                      }
                    ></Form.Control>
                  </Form.Group>
                </Row>

                <Row style={{ padding: "40px 40px 0 40px" }}>
                  <Col>
                    <Form.Group className="mb-3" controlId="form.isActive">
                      <Form.Label className="modalLabel generalFont">
                        Status <i className="text-danger">(required)</i>
                      </Form.Label>
                      <Form.Select
                        className="modalInput generalFont"
                        aria-label="Choose Item"
                        required
                        value={handleIsActive(form.isActive)}
                        onChange={(e) =>
                          setField(
                            "isActive",
                            e.target.value === "Active" ? true : false
                          )
                        }
                      >
                        <option hidden value="">
                          Choose Item
                        </option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="form.testMethod">
                      <Form.Label className="modalLabel generalFont">
                        Test Method <i className="text-danger">(required) </i>
                      </Form.Label>
                      <Form.Select
                        required
                        className="modalInput generalFont"
                        aria-label="Choose Item"
                        value={form.testMethod}
                        onChange={(e) => setField("testMethod", e.target.value)}
                        feedback="You must agree before submitting."
                      >
                        <option hidden value="">
                          Choose Item
                        </option>
                        {_.sortBy(testMethodValues, [
                          "reference_Code_description",
                        ]).map((entry) => {
                          return (
                            <option
                              key={entry.referenceTableValueId}
                              value={entry.reference_Code_description}
                            >
                              {entry.reference_Code_description}
                            </option>
                          );
                        })}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
                <Row style={{ padding: "40px 40px 0 40px" }}>
                  <Col>
                    <Form.Group
                      className="mb-3"
                      controlId="form.specimenSource"
                    >
                      <Form.Label className="modalLabel generalFont">
                        Specimen Source
                      </Form.Label>
                      <Form.Select
                        className="modalInput generalFont"
                        aria-label="Choose Item"
                        value={form.specimenSource}
                        onChange={(e) =>
                          setField("specimenSource", e.target.value)
                        }
                        feedback="You must agree before submitting."
                      >
                        <option hidden value="">
                          Choose Item
                        </option>
                        {_.sortBy(specimenSourceValues, [
                          "reference_Code_description",
                        ]).map((entry) => {
                          return (
                            <option
                              key={entry.referenceTableValueId}
                              value={entry.reference_Code_description}
                            >
                              {entry.reference_Code_description}
                            </option>
                          );
                        })}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  {showTestTypeField() && (
                    <Col>
                      <Form.Group className="mb-3" controlId="form.testType">
                        <Form.Label className="modalLabel generalFont">
                          RE Test Type
                        </Form.Label>
                        <Form.Select
                          className="modalInput generalFont"
                          aria-label="Choose Item"
                          value={form.testType}
                          onChange={(e) => setField("testType", e.target.value)}
                        >
                          <option value="">Choose Item</option>
                          {/* <option value="Treponemal">Treponemal</option>
                          <option value="Non-Treponemal">Non-Treponemal</option> */}

                          {testTypeOptions.map((entry) => {
                            return (
                              <option key={entry} value={entry}>
                                {entry}
                              </option>
                            );
                          })}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  )}
                </Row>
                <Row style={{ padding: "40px 40px 0 40px" }}>
                  <Col>
                    <Form.Group className="mb-3" controlId="form.scaleType">
                      <Form.Label className="modalLabel generalFont">
                        Scale Type <i className="text-danger">(required)</i>
                      </Form.Label>
                      <Form.Select
                        required
                        className="modalInput generalFont"
                        aria-label="Choose Item"
                        value={form.scaleType}
                        onChange={(e) => setField("scaleType", e.target.value)}
                      >
                        <option hidden value="">
                          Choose Item
                        </option>
                        {_.sortBy(scaleTypeValues, ["seqNum"]).map((entry) => {
                          return (
                            <option
                              key={entry.referenceTableValueId}
                              value={entry.reference_Code_description}
                            >
                              {entry.reference_Code_description}
                            </option>
                          );
                        })}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="form.property">
                      <Form.Label className="modalLabel generalFont">
                        Property
                      </Form.Label>
                      <Form.Select
                        className="modalInput generalFont"
                        aria-label="Choose Item"
                        value={form.property}
                        onChange={(e) => setField("property", e.target.value)}
                        feedback="You must agree before submitting."
                      >
                        <option value="">Choose Item</option>
                        {_.sortBy(propertyValues, [
                          "reference_Code_description",
                        ]).map((entry) => {
                          return (
                            <option
                              key={entry.referenceTableValueId}
                              value={entry.reference_Code_description}
                            >
                              {entry.reference_Code_description}
                            </option>
                          );
                        })}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
                <Row style={{ padding: "40px 40px 0 40px" }}>
                  <Col>
                    <Form.Group className="mb-3" controlId="form.codeSystem">
                      <Form.Label className="modalLabel generalFont">
                        Code System <i className="text-danger">(required)</i>
                      </Form.Label>
                      <Form.Select
                        required
                        className="modalInput generalFont"
                        aria-label="Choose Item"
                        value={form.codeSystem}
                        onChange={(e) => setField("codeSystem", e.target.value)}
                      >
                        <option hidden value="">
                          Choose Item
                        </option>
                        {_.sortBy(codeSystemValues, [
                          "reference_Code_description",
                        ]).map((entry) => {
                          return (
                            <option
                              key={entry.referenceTableValueId}
                              value={entry.reference_Code_description}
                            >
                              {entry.reference_Code_description}
                            </option>
                          );
                        })}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="form.timeAspect">
                      <Form.Label className="modalLabel generalFont">
                        Time Aspect
                      </Form.Label>
                      <Form.Select
                        className="modalInput generalFont"
                        aria-label="Choose Item"
                        value={form.timeAspect}
                        onChange={(e) => setField("timeAspect", e.target.value)}
                        feedback="You must agree before submitting."
                      >
                        <option value="">Choose Item</option>
                        {_.sortBy(timeAspectValues, ["seqNum"]).map((entry) => {
                          return (
                            <option
                              key={entry.referenceTableValueId}
                              value={entry.reference_Code_description}
                            >
                              {entry.reference_Code_description}
                            </option>
                          );
                        })}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
                <Row style={{ padding: "40px 40px 0 40px" }}>
                  <Col sm={6}>
                    <Form.Group
                      className="mb-3"
                      controlId="form.resultInterpretation"
                    >
                      <Form.Label className="modalLabel generalFont">
                        Result Interpretation
                      </Form.Label>
                      <Form.Select
                        className="modalInput generalFont"
                        aria-label="Choose Item"
                        value={form?.resultInterpretation}
                        onChange={(e) =>
                          setField("resultInterpretation", e.target.value)
                        }
                        feedback="You must select before submitting."
                      >
                        <option value="">Choose Item</option>
                        <option value="Set by OBX2">Set By OBX2</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>

                <Row style={{ padding: "40px 0px 0 40px" }}>
                  <Col>
                    <Form.Check
                      style={{
                        marginTop: "10px",
                        marginBottom: "20px",
                      }}
                      name="qnInterpetationChecked"
                      value={qnInterpetationChecked}
                      type="checkbox"
                      label="Qn Interpretation"
                      inline
                      onChange={(e) => {
                        setQnInterpetationChecked(e.target.checked);
                      }}
                      checked={qnInterpetationChecked}
                      required={
                        form?.scaleType &&
                        form?.scaleType?.toLowerCase().includes("quantitative")
                      }
                    />
                  </Col>
                </Row>
                <Row style={{ padding: "0px 40px 0 40px" }}>
                  <Col>
                    <Form.Group
                      className="mb-3"
                      controlId="form.qnInterpretations.units"
                    >
                      <React.Fragment>
                        <Form.Label className="modalLabel generalFont">
                          Units
                        </Form.Label>
                      </React.Fragment>
                      <Form.Select
                        disabled={!qnInterpetationChecked}
                        className="modalInput generalFont"
                        aria-label="Choose Item"
                        value={
                          !qnInterpetationChecked
                            ? ""
                            : form?.qnInterpretations?.units
                        }
                        onChange={(e) =>
                          setQnInterpretaionsField("units", e.target.value)
                        }
                        feedback="You must select before submitting."
                      >
                        <option hidden value="">
                          Choose Item
                        </option>
                        {_.sortBy(unitData, ["reference_code"]).map((entry) => {
                          return (
                            <option
                              key={entry.referenceTableValueId}
                              value={entry.reference_code}
                            >
                              {entry.reference_code}
                            </option>
                          );
                        })}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group
                      className="mb-3"
                      controlId="form.referenceRange"
                    >
                      <React.Fragment>
                        <Form.Label className="modalLabel generalFont">
                          Reference Range
                        </Form.Label>
                      </React.Fragment>
                      <Form.Control
                        disabled={!qnInterpetationChecked}
                        className="modalInput generalFont"
                        type="text"
                        placeholder="Enter Data"
                        maxLength={20}
                        value={
                          !qnInterpetationChecked
                            ? ""
                            : form?.qnInterpretations?.referenceRange
                        }
                        onChange={(e) =>
                          setQnInterpretaionsField(
                            "referenceRange",
                            e.target.value
                          )
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row style={{ padding: "0px 40px 0 40px" }}>
                  <Col>
                    <Form.Group
                      className="mb-3"
                      controlId="form.bloqInterpretation"
                    >
                      <Form.Label className="modalLabel generalFont">
                        BLOQ Interpretation{" "}
                      </Form.Label>
                      <Form.Select
                        disabled={!qnInterpetationChecked}
                        className="modalInput generalFont"
                        aria-label="Choose Item"
                        value={
                          !qnInterpetationChecked
                            ? ""
                            : form?.qnInterpretations?.bloqInterpretation
                        }
                        onChange={(e) =>
                          setQnInterpretaionsField(
                            "bloqInterpretation",
                            e.target.value
                          )
                        }
                        feedback="You must select before submitting."
                      >
                        <option hidden value="">
                          Result
                        </option>
                        {TEST_RESULT_OPTIONS.sort((a, b) =>
                          a > b ? 1 : -1
                        ).map((entry) => {
                          return (
                            <option key={entry} value={entry}>
                              {entry}
                            </option>
                          );
                        })}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group
                      className="mb-3"
                      controlId="form.aloqInterpretation"
                    >
                      <Form.Label className="modalLabel generalFont">
                        ALOQ Interpretation{" "}
                      </Form.Label>
                      <Form.Select
                        disabled={!qnInterpetationChecked}
                        className="modalInput generalFont"
                        aria-label="Choose Item"
                        value={
                          !qnInterpetationChecked
                            ? ""
                            : form?.qnInterpretations?.aloqInterpretation
                        }
                        onChange={(e) =>
                          setQnInterpretaionsField(
                            "aloqInterpretation",
                            e.target.value
                          )
                        }
                        feedback="You must select before submitting."
                      >
                        <option hidden value="">
                          Result
                        </option>
                        {TEST_RESULT_OPTIONS.sort((a, b) =>
                          a > b ? 1 : -1
                        ).map((entry) => {
                          return (
                            <option key={entry} value={entry}>
                              {entry}
                            </option>
                          );
                        })}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
                {qnInterpetationChecked && (
                  <Row style={{ padding: "40px 40px 0 40px" }}>
                    <Form.Group
                      className="mb-3"
                      controlId="form.interpretation"
                    >
                      <div className="cardBody">
                        <img
                          src={`${validateAndSanitizeUrl(
                            S3_URL
                          )}rules-details-icon.png`}
                          style={{
                            width: "20px",
                            height: "18px",
                          }}
                          alt=""
                        ></img>
                        &nbsp; Qn Interpretation Decision Table
                      </div>
                    </Form.Group>
                    <div
                      className="tableContainerNoScroll"
                      style={{ marginBottom: "10px" }}
                    >
                      <Table className="tableN" bordered hover size="sm">
                        <thead>
                          <tr>
                            <th style={{ paddingLeft: "15px" }}>Value</th>
                            <th style={{ paddingLeft: "15px" }}>Value</th>
                            <th
                              style={{ minWidth: "50px", paddingLeft: "15px" }}
                            >
                              Result (Output)
                            </th>
                            <th style={{ width: "50px" }}></th>
                          </tr>
                          <tr>
                            <th
                              width="20%"
                              className="decisionTableTh min-width-150"
                            >
                              {
                                <Form.Select
                                  name="operator"
                                  className="decisionTableCellInput"
                                  aria-label="Operator"
                                  required={validateDecisionTable()}
                                  value={
                                    interpretations[0]?.qnInterpretationConditions?.find(
                                      (obj) => obj.seqNum == 1
                                    )?.operator
                                  }
                                  onChange={(event) =>
                                    setOperator(1, event.target.value)
                                  }
                                >
                                  <option value="">Operator</option>
                                  {OPERATORS_WITH_RATO.map((operator) => (
                                    <option value={operator}>{operator}</option>
                                  ))}
                                </Form.Select>
                              }
                            </th>{" "}
                            <th
                              width="20%"
                              className="decisionTableTh min-width-150"
                            >
                              {
                                <Form.Select
                                  required={validateDecisionTable()}
                                  name="operator"
                                  className="decisionTableCellInput"
                                  aria-label="Operator"
                                  value={
                                    interpretations[0]?.qnInterpretationConditions?.find(
                                      (obj) => obj.seqNum == 2
                                    )?.operator
                                  }
                                  onChange={(event) =>
                                    setOperator(2, event.target.value)
                                  }
                                >
                                  <option value="">Operator</option>{" "}
                                  {OPERATORS_WITH_RATO.map((operator) => (
                                    <option value={operator}>{operator}</option>
                                  ))}
                                </Form.Select>
                              }
                            </th>
                            <th className="decisionTableTh min-width-150"></th>
                            <th
                              className="decisionTableTh"
                              style={{ width: "50px" }}
                            ></th>
                          </tr>
                        </thead>
                        <tbody>
                          {interpretations
                            .sort(
                              (a, b) =>
                                a?.qnInterpretationActions[0]?.rowNum -
                                b?.qnInterpretationActions[0]?.rowNum
                            )
                            .map((interpretation, index) => {
                              return (
                                <tr>
                                  <td
                                    style={{
                                      backgroundColor:
                                        interpretation?.qnInterpretationConditions?.find(
                                          (obj) => obj.seqNum == 1
                                        )?.valueRHS === null
                                          ? "#d1d1d1"
                                          : "white",
                                    }}
                                  >
                                    <Dropdown
                                      as={ButtonGroup}
                                      autoClose="outside"
                                    >
                                      {interpretation?.qnInterpretationConditions?.find(
                                        (obj) => obj.seqNum == 1
                                      )?.valueRHS === null ? (
                                        <>
                                          <Form.Text className="decisionTableCellInput">
                                            Null
                                          </Form.Text>
                                          <Dropdown.Toggle
                                            as={CustomToggleNull}
                                            split
                                          />
                                        </>
                                      ) : (
                                        <>
                                          {interpretation?.qnInterpretationConditions?.find((obj) => obj.seqNum == 1)
                                            ?.operator.includes("Ratio") ? (
                                            <>
                                              <RatioTextField
                                                required={validateDecisionTable()}
                                                name={
                                                  interpretation?.qnInterpretationConditions?.find(
                                                    (obj) => obj.seqNum == 1
                                                  )?.sourceField
                                                }
                                                value={
                                                  interpretation?.qnInterpretationConditions?.find(
                                                    (obj) => obj.seqNum == 1
                                                  )?.valueRHS
                                                }
                                                onChange={(value) =>
                                                  updateInputDecision(
                                                    interpretation,
                                                    index,
                                                    1,
                                                    value
                                                  )
                                                }
                                              />{" "}
                                              <Dropdown.Toggle
                                                as={CustomToggleRatio}
                                                split
                                              />
                                            </>
                                          ) : (
                                            <>
                                              <Form.Control
                                                required={validateDecisionTable()}
                                                className="decisionTableCellInput"
                                                placeholder="Enter Value"
                                                name={
                                                  interpretation?.qnInterpretationConditions?.find(
                                                    (obj) => obj.seqNum == 1
                                                  )?.sourceField
                                                }
                                                value={
                                                  interpretation?.qnInterpretationConditions?.find(
                                                    (obj) => obj.seqNum == 1
                                                  )?.valueRHS
                                                }
                                                onChange={(event) =>
                                                  updateInputDecision(
                                                    interpretation,
                                                    index,
                                                    1,
                                                    event.target.value
                                                  )
                                                }
                                              />
                                              <Dropdown.Toggle
                                                as={CustomToggleText}
                                                split
                                              />
                                            </>
                                          )}
                                        </>
                                      )}

                                      <Dropdown.Menu className="noTransformFullScreen">
                                        <Dropdown.Item>
                                          <>
                                            {interpretation?.qnInterpretationConditions?.find((obj) => obj.seqNum == 1)
                                              ?.operator.includes("Ratio") ? (
                                              <RatioTextField
                                                name={
                                                  interpretation?.qnInterpretationConditions?.find(
                                                    (obj) => obj.seqNum == 1
                                                  )?.sourceField
                                                }
                                                value={
                                                  interpretation?.qnInterpretationConditions?.find(
                                                    (obj) => obj.seqNum == 1
                                                  )?.valueRHS
                                                }
                                                onChange={(value) =>
                                                  updateInputDecision(
                                                    interpretation,
                                                    index,
                                                    1,
                                                    value
                                                  )
                                                }
                                              />
                                            ) : (
                                              <Form.Control
                                                className="decisionTableCellInput"
                                                placeholder="Enter Value"
                                                name={
                                                  interpretation?.qnInterpretationConditions?.find(
                                                    (obj) => obj.seqNum == 1
                                                  )?.sourceField
                                                }
                                                value={
                                                  interpretation?.qnInterpretationConditions?.find(
                                                    (obj) => obj.seqNum == 1
                                                  )?.valueRHS
                                                }
                                                onChange={(event) =>
                                                  updateInputDecision(
                                                    interpretation,
                                                    index,
                                                    1,
                                                    event.target.value
                                                  )
                                                }
                                              />
                                            )}
                                          </>
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          name={
                                            interpretation?.qnInterpretationConditions?.find(
                                              (obj) => obj.seqNum == 1
                                            )?.sourceField
                                          }
                                          onClick={(event) =>
                                            updateInputDecision(
                                              interpretation,
                                              index,
                                              1,
                                              null
                                            )
                                          }
                                        >
                                          Ignore
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </td>

                                  <td
                                    style={{
                                      backgroundColor:
                                        interpretation?.qnInterpretationConditions?.find(
                                          (obj) => obj.seqNum == 2
                                        )?.valueRHS === null
                                          ? "#d1d1d1"
                                          : "white",
                                    }}
                                  >
                                    {" "}
                                    <Dropdown
                                      as={ButtonGroup}
                                      autoClose="outside"
                                    >
                                      {interpretation?.qnInterpretationConditions?.find(
                                        (obj) => obj.seqNum == 2
                                      )?.valueRHS === null ? (
                                        <>
                                          <Form.Text className="decisionTableCellInput ">
                                            Null
                                          </Form.Text>
                                          <Dropdown.Toggle
                                            as={CustomToggleNull}
                                            split
                                          />
                                        </>
                                      ) : (
                                        <>
                                          {interpretation?.qnInterpretationConditions?.find((obj) => obj.seqNum == 2)
                                            ?.operator.includes("Ratio") ? (
                                            <>
                                              <RatioTextField
                                                required={validateDecisionTable()}
                                                name={
                                                  interpretation?.qnInterpretationConditions?.find(
                                                    (obj) => obj.seqNum == 2
                                                  )?.sourceField
                                                }
                                                value={
                                                  interpretation?.qnInterpretationConditions?.find(
                                                    (obj) => obj.seqNum == 2
                                                  )?.valueRHS
                                                }
                                                onChange={(value) =>
                                                  updateInputDecision(
                                                    interpretation,
                                                    index,
                                                    2,
                                                    value
                                                  )
                                                }
                                              />
                                              <Dropdown.Toggle
                                                as={CustomToggleRatio}
                                                split
                                              />
                                            </>
                                          ) : (
                                            <>
                                              <Form.Control
                                                required={validateDecisionTable()}
                                                className="decisionTableCellInput"
                                                placeholder="Enter Value"
                                                name={
                                                  interpretation?.qnInterpretationConditions?.find(
                                                    (obj) => obj.seqNum == 2
                                                  )?.sourceField
                                                }
                                                value={
                                                  interpretation?.qnInterpretationConditions?.find(
                                                    (obj) => obj.seqNum == 2
                                                  )?.valueRHS
                                                }
                                                onChange={(event) =>
                                                  updateInputDecision(
                                                    interpretation,
                                                    index,
                                                    2,
                                                    event.target.value
                                                  )
                                                }
                                              />
                                              <Dropdown.Toggle
                                                as={CustomToggleText}
                                                split
                                              />
                                            </>
                                          )}
                                        </>
                                      )}

                                      <Dropdown.Menu className="noTransformFullScreen">
                                        <Dropdown.Item>
                                          <>
                                            {interpretation?.qnInterpretationConditions?.find((obj) => obj.seqNum == 2)
                                              ?.operator.includes("Ratio") ? (
                                              <RatioTextField
                                                name={
                                                  interpretation?.qnInterpretationConditions?.find(
                                                    (obj) => obj.seqNum == 2
                                                  )?.sourceField
                                                }
                                                value={
                                                  interpretation?.qnInterpretationConditions?.find(
                                                    (obj) => obj.seqNum == 2
                                                  )?.valueRHS
                                                }
                                                onChange={(value) => {
                                                  updateInputDecision(
                                                    interpretation,
                                                    index,
                                                    2,
                                                    value
                                                  );
                                                }}
                                              />
                                            ) : (
                                              <Form.Control
                                                className="decisionTableCellInput"
                                                placeholder="Enter Value"
                                                name={
                                                  interpretation?.qnInterpretationConditions?.find(
                                                    (obj) => obj.seqNum == 2
                                                  )?.sourceField
                                                }
                                                value={
                                                  interpretation?.qnInterpretationConditions?.find(
                                                    (obj) => obj.seqNum == 2
                                                  )?.valueRHS
                                                }
                                                onChange={(event) =>
                                                  updateInputDecision(
                                                    interpretation,
                                                    index,
                                                    2,
                                                    event.target.value
                                                  )
                                                }
                                              />
                                            )}
                                          </>
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          name={
                                            interpretation?.qnInterpretationConditions?.find(
                                              (obj) => obj.seqNum == 2
                                            )?.sourceField
                                          }
                                          onClick={(event) =>
                                            updateInputDecision(
                                              interpretation,
                                              index,
                                              2,
                                              null
                                            )
                                          }
                                        >
                                          Ignore
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </td>

                                  <td>
                                    <Form.Select
                                      required={validateDecisionTable()}
                                      name="column999"
                                      className="decisionTableCellInput"
                                      aria-label="Object"
                                      value={
                                        interpretation?.qnInterpretationActions?.[0].valueRHS
                                      }
                                      onChange={(event) =>
                                        updateInputDecisionOutput(
                                          interpretation,
                                          index,
                                          event.target.value
                                        )
                                      }
                                    >
                                      <option hidden value="">
                                        Select
                                      </option>
                                      {TEST_RESULT_OPTIONS.sort((a, b) =>
                                        a > b ? 1 : -1
                                      ).map((entry) => {
                                        return (
                                          <option key={entry} value={entry}>
                                            {entry}
                                          </option>
                                        );
                                      })}
                                    </Form.Select>
                                  </td>

                                  <td>
                                    <Button
                                      onClick={(event) =>
                                        removeRow(interpretation, index)
                                      }
                                      className="removeButtonStyle generalFont flexCenter "
                                    >
                                      {" "}
                                      <img
                                        src={`${validateAndSanitizeUrl(
                                          S3_URL
                                        )}delete-icon.png`}
                                        className="buttonIcon"
                                        alt=""
                                      ></img>
                                    </Button>
                                  </td>
                                </tr>
                              );
                            })}

                          <tr>
                            <td colSpan="100%">
                              <Button
                                className="tableAddFieldBtn flexCenter generalFont"
                                onClick={() => addFields()}
                              >
                                <img
                                  style={{ marginRight: "10px" }}
                                  src={`${validateAndSanitizeUrl(
                                    S3_URL
                                  )}plus-vector-blue-icon.png`}
                                  className="ruleModalAddIcon"
                                  alt=""
                                ></img>
                                Add Field
                              </Button>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </Row>
                )}
                <Row style={{ padding: "40px 40px 40px 40px" }}>
                  <Form.Group className="mb-3" controlId="form.comments">
                    <Form.Label className="modalLabel generalFont">
                      Admin Comments
                    </Form.Label>
                    <Form.Control
                      className="modalInput generalFont"
                      as="textarea"
                      rows={3}
                      value={form.comments}
                      onChange={(e) => setField("comments", e.target.value)}
                    />
                  </Form.Group>
                </Row>
              </Card>
              {location?.state?.action === "update" && (
                <LOINCFormReportingLoincsCard
                  childFormRef={childFormRef}
                  loincId={location.state.selectedRow.loincId}
                />
              )}

              <Row className="noPaddMarginTop40">
                <Col className="flexCenter">
                  <Button
                    className="addNewBtn flexCenter generalFont"
                    type="submit"
                  >
                    Submit
                  </Button>
                  <Button
                    className="cancelButtonStyle generalFont flexCenter"
                    onClick={cancelForm}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>
            </Form>
          </Box>
        </Row>
      </Container>
    </>
  );
};

export default LOINCForm;
